import styled from '@emotion/styled';
import { DependentCard } from './DependentCard';
import {
  ButtonWrapper,
  InfoBanner,
  TextCaption,
  TextLink,
  token,
} from '@ferreri/prever-component-lib';
import { ExtendedGroupType, KinshipGroupType } from './rules.types';
import {
  INFO_BANNER_MESSAGES,
  KINSHIP_ADDITIONAL_DEPENDENT,
} from './constants';

type DependentCardListProps = {
  hasRuleLink?: boolean;
  ruleLinkAction?: () => void;
} & KinshipGroupType;

export const DependentCardList = (props: DependentCardListProps) => {
  const groupedSubscriptions = props.groups ?? [];

  const isAdditionalDependent =
    props.kinship?.slug === KINSHIP_ADDITIONAL_DEPENDENT.slug;
  const infoBannerText = isAdditionalDependent
    ? INFO_BANNER_MESSAGES.additional
    : INFO_BANNER_MESSAGES.default;

  return (
    <Container>
      {groupedSubscriptions?.map((item, index) => (
        <DependentCard
          key={`${item.marital_status}-${index}`}
          siblingGroup={item.siblingGroup as ExtendedGroupType[]}
          kinship={props.kinship}
          maxQuantity={item.maxQuantity}
          maxQuantityAdditional={props.maxQuantityAdditional}
          subscriptionRules={item.subscriptionRules}
          hasAdditionalDependentGlobal={props.hasAdditionalDependentGlobal}
        />
      ))}
      {props.hasAdditionalDependentGlobal && (
        <InfoBanner>
          <RulesWrapper>
            <TextCaption>{infoBannerText}</TextCaption>
            {props.hasRuleLink && (
              <ButtonWrapper onClick={() => props.ruleLinkAction()}>
                <TextLink>Consultar as regras</TextLink>
              </ButtonWrapper>
            )}
          </RulesWrapper>
        </InfoBanner>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingSmall};
`;

const RulesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXxSmall};
  width: 100%;
`;
